import { PriceScopeType } from '../constants/price-scope-type.js';
// WHY: mirrors chk_price_rule_scope (20260829120000_pricing_engine_v2/migration.sql) -- keep both in sync when a scope type is added or its required columns change
export const SCOPE_TYPE_RULES = [
    {
        scopeTypeId: PriceScopeType.CATEGORY_DEFAULT,
        label: 'category default',
        customerRequired: false,
        productRequired: false,
    },
    {
        scopeTypeId: PriceScopeType.MARKET,
        label: 'market',
        customerRequired: false,
        productRequired: false,
    },
    {
        scopeTypeId: PriceScopeType.PRODUCT,
        label: 'product',
        customerRequired: false,
        productRequired: true,
    },
    {
        scopeTypeId: PriceScopeType.ACCOUNT,
        label: 'account',
        customerRequired: true,
        productRequired: false,
    },
    {
        scopeTypeId: PriceScopeType.ACCOUNT_PRODUCT,
        label: 'account-product',
        customerRequired: true,
        productRequired: true,
    },
];
//# sourceMappingURL=scope-type-rules.js.map